import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { clickElement, focusElemnt, isEmpty } from '../../../../common/helper'
import Datepicker from '../../../../common/datePicker'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import DropDownOA from '../../../../common/dropDownOA'
import moment from 'moment'
import { businessList, columnDefs, columnDefsExcel, headCellStyles, paymentTypeList, providerList } from './constants'
import TablePaginationCustom from '../../../../common/TablePagination'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { connect, useDispatch } from 'react-redux'
import { getQRTransactionReportData } from '../../../../../store/Acounting/acounting_action'
import { getBranchDetails, getUserMasterTableData } from '../../../../../store/branchAndUserMaster/BUMAction'
import { GetRequest, GetRequestNoHeader, PostRequest } from '../../../../common/api'
import SuccessAndErrorModal from '../../../../common/SuccessAndErrorModal'
import { BranchRechargeConfirm, BranchRechargeReject, getDQRDetailsInsertUpdate } from '../../../../../store/booking/booking_action'
import { updateAlertError } from '../../../../../store/common/common_action'
import FilterAltIcon from '@mui/icons-material/FilterAlt'

const QRTransactionReport = (props) => {
    const {
        data: { common, branchAndUserMasterReducer }, getQRTransactionReportData, getBranchDetails, getUserMasterTableData, BranchRechargeConfirm, updateAlertError
    } = props
    const { BranchDetailsList, userMasterTableData } = branchAndUserMasterReducer
    const dispatch = useDispatch()
    const { loginData } = common
    const reportOptionsList = [{ id: 1, name: 'Company Wise' },
    { id: 2, name: 'Branch Wise' },
        // { id: 3, name: 'User Wise' }
    ]
    const [filters, setFilters] = useState({ fromDate: moment(new Date()), toDate: moment(new Date()), provider: providerList?.[0], business: businessList?.[0], paymentType: paymentTypeList?.[0], rptOptions: reportOptionsList?.[0], branch: '', user: '' })
    const [tableData, setTableData] = useState([])
    const [reportData, setReportData] = useState([])
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [page, setPage] = useState(0)
    const [showTable, setShowTable] = useState(false)
    const [headers, setHeaders] = useState([])
    const [isSuccess, setIsSuccess] = useState(false)
    const [searchData, setSearchData] = useState({
        Provider: "",
        Business: "",
        PayType: "",
        Mode: "",
        ModeV: "",
        OrderID: "",
        TranID: "",
        TranIniOn: '',
        TranCompOn: '',
        TranAmt: '',
        TranFee: '',
        GST: '',
        utrNo: '',
        TranStaus: '',
        PaymentStatus: '',
        PNR: '',
        TransDate: '',
        settelmentStatus: '',
        settelmentId: '',
        settelmentDateTime: '',
        BookedBy: ''
    })

    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    const headerDef = [
        { header: 'From Transaction Date', headerName: 'From Transaction Date', field: 'fromDate', headerSx: { textAlign: 'left', minWidth: '100px' }, showfilter: false, allowSorting: true },
        { header: 'To Transaction Date', headerName: 'To Transaction Date', field: 'toDate', headerSx: { textAlign: 'left', minWidth: '100px' }, showfilter: false, allowSorting: true },
        { header: 'Provider', headerName: 'Provider', field: 'provider', headerSx: { textAlign: 'left', minWidth: '100px' }, showfilter: false, allowSorting: true },
        { header: 'Business', headerName: 'Business', field: 'business', headerSx: { textAlign: 'left', minWidth: '100px' }, showfilter: false, allowSorting: true },
        { header: ' Payment Type', headerName: ' Payment Type', field: 'paymentType', headerSx: { textAlign: 'left', minWidth: '100px' }, showfilter: false, allowSorting: true },
        { header: 'Report Options', headerName: 'Report Options', field: 'rptOptions', headerSx: { textAlign: 'left', minWidth: '100px' }, showfilter: false, allowSorting: true },
    ]
    useEffect(() => {
        if (filters?.rptOptions?.id === 1) {
            setHeaders(headerDef)
        } else if (filters?.rptOptions?.id === 2) {
            setHeaders([...headerDef, { header: 'Selected Branch', headerName: 'Selected Branch', field: 'branch', headerSx: { textAlign: 'left', minWidth: '100px' }, showfilter: false, allowSorting: true },])
        } else if (filters?.rptOptions?.id === 3) {
            setHeaders([...headerDef, { header: 'Selected Branch', headerName: 'Selected Branch', field: 'branch', headerSx: { textAlign: 'left', minWidth: '100px' }, showfilter: false, allowSorting: true },
            { header: 'Selected User', headerName: 'Selected User', field: 'user', headerSx: { textAlign: 'left', minWidth: '100px' }, showfilter: false, allowSorting: true },
            ])
        }
    }, [filters?.rptOptions])
    useEffect(() => {
        if (!isEmpty(loginData)) {
            const body = {
                intUserID: 0,
                intCompanyID: loginData.intCompanyID,
                intBranchID: 0,
                strBranchName: "",
                strBranchCode: "",
                intStateID: 0,
                intCityID: 0,
                intIsActive: 1
            }
            getBranchDetails(body)
        }
    }, [loginData])
    // useEffect(()=>{
    //     if(filters?.branch!==''){
    //         const body = {
    //             intUserID: 0,
    //             intCompanyID: loginData.intCompanyID,
    //             intBranchID: filters?.branch?.BranchID,
    //             strUserName: '',
    //             strLoginID: '',
    //             strPassword: '',
    //             strContactNo: '',
    //             intRoleID: 0,
    //             intIsActive: 1,
    //         }
    //         getUserMasterTableData(body)
    //     }
    // },[filters?.branch])
    useEffect(() => {
        if (BranchDetailsList?.length > 0) {
            const newBranch = BranchDetailsList?.filter((item) => item?.BranchID === loginData?.intBranchID)
            setFilters((prev) => ({
                ...prev,
                branch: newBranch
            }))
        }
    }, [BranchDetailsList])
    const handleLoad = async () => {
        if (filters?.provider === '') {
            updateAlertError({ show: true, msg: 'Please Select The Provider', nextId: '' })
            return
        } else if (filters?.business === '') {
            updateAlertError({ show: true, msg: 'Please Select The Business', nextId: '' })
            return
        } else if (filters?.paymentType === '') {
            updateAlertError({ show: true, msg: 'Please Select Payment Type', nextId: '' })
            return
        } else if (filters?.rptOptions?.id === 2 && filters?.branch === '') {
            updateAlertError({ show: true, msg: 'Please Select Branch', nextId: '' })
            return
        } else {
            let settlementBody = {
                dateType: 1,
                fromdate: moment(filters?.fromDate).format('YYYY-MM-DD'),
                todate: moment(filters?.toDate).format('YYYY-MM-DD'),
                bankProviderId: filters?.provider?.id,
                businessVerticalId: filters?.business?.id,
                paymentTypeId: filters?.paymentType?.id === 7 ? 1 : filters?.paymentType?.id,
                modeId: filters?.rptOptions?.id,
                branchUserId: filters?.rptOptions?.id === 1 ? 0 : filters?.branch?.BranchID
            }
            const settlementData = await GetRequestNoHeader(`https://gpg.iamgds.com/api/v1/settlements/qr-settlement-report?`, settlementBody)
            const notConsumeBody = {
                agentId: 0,
                agentUserId: 0,
                application: 'crs',
                branchId: filters?.rptOptions?.id === 1 ? 0 : filters?.branch?.BranchID,
                branchUserId: 0,
                companyId: loginData?.intCompanyID,
                deviceId: '',
                deviceType: 'web',
                vertical: 'cargo'
            }
            const notConsumeData = await PostRequest(`https://gpg.iamgds.com/api/v1/orders/notConsumed?`, notConsumeBody)
            // const notConsumedOrderIds = new Set(notConsumeData?.data?.map(item => item.orderId));
            const notConsumedOrderIds = new Set(notConsumeData?.data ? notConsumeData.data.map(item => item.orderId) : []);

            let body = {
                fromdate: moment(filters?.fromDate).format('YYYY-MM-DD'),
                todate: moment(filters?.toDate).format('YYYY-MM-DD'),
                provid: filters?.provider?.id,
                business: filters?.business?.id,
                paytype: filters?.paymentType?.id,
                companyID: loginData?.intCompanyID,
                branchID: filters?.rptOptions?.id === 1 ? 0 : filters?.branch?.BranchID
            }
            getQRTransactionReportData(body).then((res) => {
                if (res?.status) {
                    if (res?.Data?.Table?.length > 0) {
                        let newData = res.Data.Table.map((val, index) => {
                            // Find matching settlement data by OrderID
                            const orderIdToCheck = String(val.OrderID).trim();
                            // const matchingSettlement = settlementData?.data?.find(settlement =>
                            //     String(settlement.orderId).trim() === orderIdToCheck
                            // );
                            const matchingSettlement = settlementData?.data ? settlementData.data.find(settlement =>
                                String(settlement.orderId).trim() === orderIdToCheck
                            ) : null;
                            return {
                                ...val,
                                srNo: index + 1,
                                check: notConsumedOrderIds.has(Number(val.OrderID)), // Use has() to check for existence
                                settelmentId: matchingSettlement ? matchingSettlement.settelmentId : "-",
                                utrNo: matchingSettlement ? matchingSettlement.utrNo : "-",
                                settelmentStatus: matchingSettlement ? matchingSettlement.settelmentStatus : "Not Settled",
                                settelmentDateTime: matchingSettlement ? moment(matchingSettlement.settelmentDateTime).format('DD-MMM-YYYY hh:mm A') : "-",
                                PaymentStatus: matchingSettlement ? matchingSettlement?.pgStatus:val?.PaymentStatus
                            };
                        });

                        setTableData(newData)
                        setReportData(newData)
                    } else {
                        setTableData([])
                        setReportData([])
                    }
                } else {
                    setTableData([])
                    setReportData([])
                    updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' })
                }
            })
            setShowTable(true)
        }
    }
    const handleRecheck = (val) => {
        GetRequest(`https://gpg.iamgds.com/api/v1/orders/${val?.OrderID}/status`, {}).then((statusRes) => {
            if (statusRes?.isSuccess && val.PNR !== null && statusRes?.data?.status !== '') {
                let obj = {
                    orderId: statusRes?.data?.orderId,//
                    amount: statusRes?.data?.amount,//
                    pgCharge: statusRes?.data?.pgCharge,//
                    pgAmount: statusRes?.data?.pgAmount,//
                    Status: statusRes?.data?.status,//confirm
                    merchantTxnId: statusRes?.data?.merchantTxnId,//
                    pgTxnId: statusRes?.data?.pgTxnId,//
                    statusTime: statusRes?.data?.statusTime,//
                    CompanyID: loginData?.intCompanyID,
                    BranchID: loginData?.intBranchID,
                    qrUTRNumber: statusRes?.data?.qrUTRNumber,//
                    RechargeStatus: '',//confirm
                    transferfee: statusRes?.data?.transferFee,//
                    PaymentProductTypeID: 4,
                    BusinessVerticalID: 3,
                    RechargeID: val.PNR//
                }
                dispatch(getDQRDetailsInsertUpdate(obj)).then((dispatchResult) => {
                    if (dispatchResult?.status === "Success") {
                        if (statusRes.data.status === 'PAYMENT_SUCCESS') {
                            const confmBody = {
                                intCompanyID: loginData?.intCompanyID,
                                intBranchID: loginData?.intBranchID,
                                intRechargeID: val.PNR,
                                intUserIDRejected: 0,
                                intUserIDConfirmed: loginData?.intUserID
                            }
                            BranchRechargeConfirm(confmBody).then((branchrechargeRes) => {
                                //check branchrechargeRes status is sucess
                                if (branchrechargeRes?.status === 'Success') {
                                    GetRequestNoHeader(`https://gpg.iamgds.com/api/v1/orders/${val?.OrderID}/consumed?ConsumptionId=${val?.PNR}`).then((consumeRes) => {
                                        if (consumeRes?.isSuccess) {
                                            setIsSuccess(true)
                                        }
                                    })
                                }
                            }).catch((err)=>{
                                updateAlertError({ show: true, msg: err, nextId: '' })
                            })
                        } else if (statusRes.data.status === 'PAYMENT_FAILURE' || statusRes.data.status === 'PAYMENT_INITIATE_FAILED') {
                            const rejectBody = {
                                intCompanyID: loginData?.intCompanyID,
                                intBranchID: loginData?.intBranchID,
                                intRechargeID: val?.PNR,
                                intUserIDRejected: loginData?.intUserID
                            }
                            dispatch(BranchRechargeReject(rejectBody)).then(() => {
                                updateAlertError({ show: true, msg: `Recharge failed!. Please Try again. `, nextId: '' })
                            })
                        }
                    } else {
                        if (dispatchResult?.status === 'Fail') {
                            updateAlertError({ show: true, msg: dispatchResult?.ErrMessage, nextId: '' })
                        }
                    }
                }).catch((err) => {
                    updateAlertError({ show: true, msg: err, nextId: '' })
                })
            }
        })
        // const confmBody = {
        //     intCompanyID: loginData?.intCompanyID,
        //     intBranchID: filters?.rptOptions?.id === 1 ? 0 : filters?.branch?.BranchID,
        //     intRechargeID: val?.PNR,
        //     intUserIDRejected: 0,
        //     intUserIDConfirmed: loginData?.intUserID
        // }
        // BranchRechargeConfirm(confmBody).then(() => {
        //     GetRequestNoHeader(`https://gpg.iamgds.com/api/v1/orders/${val?.OrderID}/consumed?ConsumptionId=${val?.PNR}`).then((consumeRes) => {
        //         if (consumeRes?.isSuccess) {
        //             setIsSuccess(true)
        //         } else {
        //             updateAlertError({ show: true, msg: `Recharge Request Failed.\nTry Again Later.`, nextId: '' })
        //             return
        //         }
        //     })
        // })
    }
    useEffect(() => {
        let fiterData = reportData?.filter((val) =>
            (searchData?.Provider === "" || (val?.Provider && val?.Provider?.toLocaleLowerCase().includes(searchData?.Provider?.toLocaleLowerCase()))) &&
            (searchData?.Business === "" || (val?.Business && val?.Business?.toLocaleLowerCase().includes(searchData?.Business?.toLocaleLowerCase()))) &&
            (searchData?.PayType === "" || (val?.PayType && val?.PayType?.toLocaleLowerCase().includes(searchData?.PayType?.toLocaleLowerCase()))) &&
            (searchData?.Mode === "" || (val?.Mode && val?.Mode?.toLocaleLowerCase().includes(searchData?.Mode?.toLocaleLowerCase()))) &&
            (searchData?.ModeV === "" || (val?.ModeV && val?.ModeV?.toLocaleLowerCase().includes(searchData?.ModeV?.toLocaleLowerCase()))) &&
            (searchData?.OrderID === "" || (val?.OrderID && val?.OrderID?.toString().toLocaleLowerCase().includes(searchData?.OrderID))) &&
            (searchData?.TranID === "" || (val?.TranID && val?.TranID?.toString().toLocaleLowerCase().includes(searchData?.TranID))) &&
            (searchData?.TranIniOn === "" || (val?.TranIniOn && val?.TranIniOn?.toLocaleLowerCase().includes(searchData?.TranIniOn?.toLocaleLowerCase()))) &&
            (searchData?.TranCompOn === "" || (val?.TranCompOn && val?.TranCompOn?.toLocaleLowerCase().includes(searchData?.TranCompOn?.toLocaleLowerCase()))) &&
            // (searchData?.TranIniOn === "" || (val?.TranIniOn && val?.TranIniOn?.toLocaleLowerCase().includes(searchData?.TranIniOn?.toLocaleLowerCase()))) &&
            (searchData?.TranAmt === "" || (val?.TranAmt && val?.TranAmt?.toString().toLocaleLowerCase().includes(searchData?.TranAmt))) &&
            (searchData?.TranFee === "" || (val?.TranFee && val?.TranFee?.toString().toLocaleLowerCase().includes(searchData?.TranFee))) &&
            (searchData?.GST === "" || (val?.GST && val?.GST?.toString().toLocaleLowerCase().includes(searchData?.GST))) &&
            (searchData?.utrNo === "" || (val?.utrNo && val?.utrNo?.toString().toLocaleLowerCase().includes(searchData?.utrNo))) &&
            (searchData?.TranStaus === "" || (val?.TranStaus && val?.TranStaus?.toLocaleLowerCase().includes(searchData?.TranStaus?.toLocaleLowerCase()))) &&
            (searchData?.PaymentStatus === "" || (val?.PaymentStatus && val?.PaymentStatus?.toLocaleLowerCase().includes(searchData?.PaymentStatus?.toLocaleLowerCase()))) &&
            (searchData?.PNR === "" || (val?.PNR && val?.PNR?.toLocaleLowerCase().includes(searchData?.PNR?.toLocaleLowerCase()))) &&
            (searchData?.TransDate === "" || (val?.TransDate && val?.TransDate?.toLocaleLowerCase().includes(searchData?.TransDate?.toLocaleLowerCase()))) &&
            (searchData?.TranAmt === "" || (val?.TranAmt && val?.TranAmt?.toString().toLocaleLowerCase().includes(searchData?.TranAmt))) &&
            (searchData?.settelmentStatus === "" || (val?.settelmentStatus && val?.settelmentStatus?.toLocaleLowerCase().includes(searchData?.settelmentStatus?.toLocaleLowerCase()))) &&
            (searchData?.settelmentId === "" || (val?.settelmentId && val?.settelmentId?.toString().toLocaleLowerCase().includes(searchData?.settelmentId))) &&
            (searchData?.settelmentDateTime === "" || (val?.settelmentDateTime && val?.settelmentDateTime?.toLocaleLowerCase().includes(searchData?.settelmentDateTime?.toLocaleLowerCase()))) &&
            (searchData?.BookedBy === "" || (val?.BookedBy && val?.BookedBy?.toLocaleLowerCase().includes(searchData?.BookedBy?.toLocaleLowerCase())))
        );
        setTableData(fiterData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchData]);
    const handleSearchData = (event, field) => {
        let value = event.target.value.toString(); // Convert value to string
        setSearchData({ ...searchData, [field]: value });
    }
    return (
        <>
            <Box sx={{ ...sx.reportFlex, flexWrap: 'nowrap' }}>
                <Item className="input--container bookingDatePicker" sx={sx.itemsx} style={{ width: '14.6%' }}>
                    <Datepicker
                        label={`From Transaction Date`}
                        id='qrFromDate'
                        width="100%"
                        value={filters?.fromDate}
                        dateChange={(date) => {
                            setFilters((prev) => ({
                                ...prev,
                                fromDate: date
                            }))
                            setShowTable(false)
                            focusElemnt('prtyBkngToDate')
                        }}
                    />
                </Item>
                <Item className="input--container bookingDatePicker" sx={sx.itemsx} style={{ width: '14.6%' }}>
                    <Datepicker
                        label={`To Transaction Date`}
                        id='qrToDate'
                        width="100%"
                        value={filters?.toDate}
                        dateChange={(date) => {
                            setFilters((prev) => ({
                                ...prev,
                                toDate: date
                            }))
                            setShowTable(false)
                            focusElemnt('prtyBkngToDate')
                        }}
                    />
                </Item>
                <Item sx={sx.itemsx} style={{ width: '14.6%' }}>
                    <DropDownOA
                        id={'qrProvider'}
                        label={'Provider'}
                        width="100%"
                        searchPlaceholder={'Search Provider'}
                        data={providerList || []}
                        defaultvalue={filters?.provider?.name}
                        value={filters?.provider?.name}
                        dataKey={`name`}
                        idKey={`id`}
                        onSelect={(val) => {
                            setFilters((prev) => ({
                                ...prev,
                                provider: val
                            }))
                            setShowTable(false)
                        }}
                        nextId='prtyBkngGoBtn'
                        prevId=''
                        onSelResetVal={true}
                    />
                </Item>
                <Item sx={sx.itemsx} style={{ width: '14.6%' }}>
                    <DropDownOA
                        id={'qrBusiness'}
                        label={'Business'}
                        width="100%"
                        searchPlaceholder={'Search Business'}
                        data={businessList || []}
                        defaultvalue={filters?.business?.name}
                        value={filters?.business?.name}
                        dataKey={`name`}
                        idKey={`id`}
                        onSelect={(val) => {
                            setFilters((prev) => ({
                                ...prev,
                                business: val
                            }))
                            setShowTable(false)
                        }}
                        nextId='prtyBkngGoBtn'
                        prevId=''
                        onSelResetVal={true}
                    />
                </Item>
                <Item sx={sx.itemsx} style={{ width: '14.6%' }}>
                    <DropDownOA
                        id={'qrPaymentType'}
                        label={'Payment Type'}
                        width="100%"
                        searchPlaceholder={'Search Payment Type'}
                        data={paymentTypeList || []}
                        defaultvalue={filters?.paymentType?.name}
                        value={filters?.paymentType?.name}
                        dataKey={`name`}
                        idKey={`id`}
                        onSelect={(val) => {
                            setFilters((prev) => ({
                                ...prev,
                                paymentType: val
                            }))
                            setShowTable(false)
                        }}
                        nextId='prtyBkngGoBtn'
                        prevId=''
                        onSelResetVal={true}
                    />
                </Item>
                <Item sx={sx.itemsx} style={{ width: '14.6%' }}>
                    <DropDownOA
                        id={'qrReportOptions'}
                        label={'Report Options'}
                        width="100%"
                        searchPlaceholder={'Search Report Options'}
                        data={reportOptionsList || []}
                        defaultvalue={filters?.rptOptions?.name}
                        value={filters?.rptOptions?.name}
                        onSelect={(val) => {
                            setFilters((prev) => ({
                                ...prev, rptOptions: val
                            }))
                            setShowTable(false)
                        }}
                        dataKey={`name`}
                        idKey={`id`}
                        nextId='prtyBkngGoBtn'
                        prevId=''
                        onSelResetVal={true}
                    />
                </Item>
                {(filters?.rptOptions?.id == 2 || filters?.rptOptions?.id == 3) && <Item sx={sx.itemsx} style={{ width: '14.6%' }}>
                    <DropDownOA
                        id={'qrSelectBranch'}
                        label={'Select Branch'}
                        searchPlaceholder={'Search Branch'}
                        onSelect={(val) => {
                            setFilters((prev) => ({
                                ...prev, branch: val
                            }))
                            setShowTable(false)
                        }}
                        nextId='prtyBkngGoBtn'
                        prevId=''
                        width={'250px'}
                        data={BranchDetailsList || []}
                        defaultvalue={filters?.branch?.BranchName}
                        value={filters?.branch?.BranchName}
                        dataKey={`BranchName`}
                        idKey={`BranchID`}
                        onSelResetVal={true}
                    />
                </Item>}
                {filters?.rptOptions?.id !== 3 && <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
                    <Button
                        variant="contained"
                        // onKeyDown={(e) => navigation3(e, 'printBtn', 'gv-partyName', () => { })}
                        id={'load_Btn'}
                        sx={{ width: '100%', paddingY: '6px !important' }}
                        className="btn btn-primary"
                        onClick={() => { handleLoad() }}
                    >
                        Load
                    </Button>
                </Item>}
                {filters?.rptOptions?.id !== 3 && <Item sx={{ ...sx.itemsx }} className="">
                    <Button
                        variant="outlined"
                        color="secondary"
                        id={'printBtn'}
                        sx={{ width: '100%' }}
                        className="receiveitembtn"
                        onClick={(e) => {
                            e.preventDefault()
                            clickElement('xls-button-memo')
                        }}
                    //   onKeyDown={(e) => navigation1(e, 'memoExportPdfBtn', 'memeoShortPrint')}
                    >
                        Export
                    </Button>
                    <ReactHtmlTableToExcel
                        id="xls-button-memo"
                        table="delivery-memo-excel-tbl"
                        filename={'QR Transaction Report'}
                        sheet="sheet 1"
                        buttonText="EXPORT AS EXCEL"
                        className="excel-button"
                    />
                </Item>}
            </Box>
            {filters?.rptOptions?.id == 3 && <Box sx={{ ...sx.reportFlex, flexWrap: 'nowrap' }}>
                <Item sx={sx.itemsx} style={{ width: '14.6%' }}>
                    <DropDownOA
                        id={'qrSelectUser'}
                        label={'Select User'}
                        width="100%"
                        searchPlaceholder={'Search User'}
                        onSelect={(val) => {
                            setFilters((prev) => ({
                                ...prev, user: val
                            }))
                            setShowTable(false)
                        }}
                        nextId='prtyBkngGoBtn'
                        prevId=''
                        //  resetFlag={resetFilter}
                        data={userMasterTableData?.Table || []}
                        defaultvalue={filters?.user?.UserName}
                        value={filters?.user?.UserName}
                        dataKey={`UserName`}
                        idKey={`UserID`}
                        onSelResetVal={true}
                    />
                </Item>
                <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
                    <Button
                        variant="contained"
                        // onKeyDown={(e) => navigation3(e, 'printBtn', 'gv-partyName', () => { })}
                        id={'load_Btn'}
                        sx={{ width: '100%', paddingY: '6px !important' }}
                        className="btn btn-primary"
                        onClick={() => { handleLoad() }}
                    >
                        Load
                    </Button>
                </Item>
                <Item sx={{ ...sx.itemsx }} className="">
                    <Button
                        variant="outlined"
                        color="secondary"
                        id={'printBtn'}
                        sx={{ width: '100%' }}
                        className="receiveitembtn"
                        onClick={(e) => {
                            e.preventDefault()
                            clickElement('xls-button-memo')
                        }}
                    //   onKeyDown={(e) => navigation1(e, 'memoExportPdfBtn', 'memeoShortPrint')}
                    >
                        Export
                    </Button>
                    <ReactHtmlTableToExcel
                        id="xls-button-memo"
                        table="delivery-memo-excel-tbl"
                        filename={'QR Transaction Report'}
                        sheet="sheet 1"
                        buttonText="EXPORT AS EXCEL"
                        className="excel-button"
                    />
                </Item>
            </Box>}
            {
                showTable && <Box sx={{ ...sx.reportFlex }}>
                    <TableContainer className='scrollBlue' component={Paper} style={{ marginBottom: '5px', maxHeight: '45vh', overflowX: 'auto' }}>
                        <Table
                            stickyHeader
                            size="small"
                            aria-label="a dense table"
                            sx={{
                                '&.MuiTableCell-root': {
                                    padding: '6px 8px!important',
                                },
                            }}
                        >
                            <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
                                <TableRow>
                                    {columnDefs?.map((col, index) => (
                                        <TableCell key={`CityHeader-${index}`} sx={{
                                            ...col.headerSx,
                                            backgroundColor: '#DAEDFE',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            color: '#444',
                                            height: '36px',
                                            whiteSpace: 'pre',
                                            padding: '6px'
                                        }}>
                                            {col.headerName}
                                        </TableCell>
                                    ))}

                                </TableRow>
                                <TableRow>
                                    {columnDefs?.map((col, index) => (
                                        <TableCell key={`FTH-${index}`} style={{ height: "36px" }}>
                                        {index!==0 && index!==columnDefs?.length-1 &&<div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                                            <input
                                                id={`Contains-${index}`}
                                                className="field"
                                                name="cancelSearchInput"
                                                style={{ width: '100%', height: "24px" }}
                                                placeholder="Contains"
                                                autoComplete="off"
                                                value={searchData[col.field]}
                                                onChange={(e) => handleSearchData(e, col.field)}
                                            />
                                            <FilterAltIcon style={{ color: "#aaa" }} />
                                        </div>}
                                    </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            {tableData?.length > 0 ? <TableBody>
                                {(
                                    rowsPerPage > 0
                                        ? tableData.slice(
                                            page * rowsPerPage,
                                            page * rowsPerPage + rowsPerPage
                                        )
                                        :
                                        tableData
                                ).map((val, index) => (
                                    <TableRow>

                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right', minWidth: '50px' }}>
                                            {val?.srNo}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.Provider}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.Business}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.PayType}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.Mode}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', width: '12%', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.ModeV}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.OrderID}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', width: '12%', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.TranID}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.TranIniOn}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.TranCompOn}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.TranAmt}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px' }}>
                                            {val?.TranFee}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px' }}>
                                            {val?.GST}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px' }}>
                                            {val?.utrNo}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px' }}>
                                            {val?.TranStaus}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px' }}>
                                            {val?.PaymentStatus}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px' }}>
                                            {val?.PNR}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px' }}>
                                            {val?.TransDate}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px' }}>
                                            {val?.TranAmt}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px' }}>
                                            {val?.settelmentStatus}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px' }}>
                                            {val?.settelmentId}
                                        </TableCell> <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px' }}>
                                            {val?.settelmentDateTime}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px' }}>
                                            {val?.BookedBy}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px' }}>
                                            {val?.check && filters?.paymentType?.id === 4 && <Button
                                                variant="contained"
                                                // onKeyDown={(e) => navigation3(e, 'printBtn', 'gv-partyName', () => { })}
                                                id={'load_Btn'}
                                                sx={{ width: '100%', padding: '1px 0px !important', fontSize: '14px !important' }}
                                                className="btn btn-primary"
                                                onClick={() => { handleRecheck(val) }}
                                            >
                                                Recheck
                                            </Button>}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody> :
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={columnDefs?.length}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    marginTop: '20px',
                                                    marginBottom: '20px',
                                                    color: 'red',
                                                    fontSize: '14px',
                                                }}
                                            >
                                                <span>No Results Found For The Selected Filters.</span>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>}
                        </Table>
                        <Table
                            id='delivery-memo-excel-tbl'
                            stickyHeader
                            size="small"
                            aria-label="a dense table"
                            sx={{
                                display: 'none',
                                '&.MuiTableCell-root': {
                                    padding: '6px 8px!important',
                                },
                            }}
                        >
                            <TableHead style={{ fontWeight: 'bold' }}>
                                <TableRow>
                                    <TableCell
                                        className="reportTD"
                                        style={{ fontWeight: 'bold', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
                                        colSpan={Math.floor(columnDefsExcel?.length / 2)}

                                    >
                                        <h3 style={{ paddingLeft: '17px', fontFamily: 'Roboto', fontSize: '18px' }}>QR Transaction Report: {filters?.rptOptions?.name}</h3>
                                    </TableCell>
                                    <TableCell
                                        className="reportTD"
                                        style={{ fontWeight: 'bold', fontSize: '14px', fontWeight: '500', textAlign: 'right' }}
                                        colSpan={Math.floor(columnDefsExcel?.length / 2)}

                                    >
                                        <h3 style={{ paddingLeft: '17px', fontFamily: 'Roboto', fontSize: '18px' }}>Company Name : {loginData.strCompanyName}</h3>
                                    </TableCell>
                                </TableRow>
                                <TableRow ><TableCell colSpan={columnDefsExcel?.length}></TableCell></TableRow>
                                <TableRow>
                                    {headers?.map((col, index) => (
                                        <TableCell key={`CityHeader-${index}`}
                                            colSpan={Math.floor(columnDefsExcel?.length / headers?.length)}
                                            style={{
                                                ...col.headerSx,
                                                backgroundColor: '#DAEDFE',
                                                fontSize: '12px',
                                                fontWeight: '600',
                                                color: '#444',
                                                height: '36px',
                                                whiteSpace: 'pre',
                                                padding: '6px'
                                            }}>
                                            {col.headerName}
                                        </TableCell>
                                    ))}

                                </TableRow>
                                <TableRow >
                                    <TableCell
                                        className="ReportItemHead"
                                        style={{
                                            fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                                        }}
                                        colSpan={Math.floor(columnDefsExcel?.length / headers?.length)}
                                    >{moment(filters?.fromDate).format('DD-MMM-YY')}
                                    </TableCell>
                                    <TableCell
                                        className="ReportItemHead"
                                        style={{
                                            fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                                        }}
                                        colSpan={Math.floor(columnDefsExcel?.length / headers?.length)}
                                    >
                                        {moment(filters?.toDate).format('DD-MMM-YY')}
                                    </TableCell>
                                    <TableCell
                                        className="ReportItemHead"
                                        style={{
                                            fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                                        }}
                                        colSpan={Math.floor(columnDefsExcel?.length / headers?.length)}
                                    >
                                        {filters?.provider?.name}
                                    </TableCell>
                                    <TableCell
                                        className="ReportItemHead"
                                        style={{
                                            fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                                        }}
                                        colSpan={Math.floor(columnDefsExcel?.length / headers?.length)}
                                    >
                                        {filters?.business?.name}
                                    </TableCell>
                                    <TableCell
                                        className="ReportItemHead"
                                        style={{
                                            fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                                        }}
                                        colSpan={Math.floor(columnDefsExcel?.length / headers?.length)}
                                    >
                                        {filters?.paymentType?.name}
                                    </TableCell>
                                    <TableCell
                                        className="ReportItemHead"
                                        style={{
                                            fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                                        }}
                                        colSpan={Math.floor(columnDefsExcel?.length / headers?.length)}
                                    >
                                        {filters?.rptOptions?.name}

                                    </TableCell>
                                    {(filters?.rptOptions?.id === 2 || filters?.rptOptions?.id === 3) && <TableCell
                                        className="ReportItemHead"
                                        style={{
                                            fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                                        }}
                                        colSpan={Math.floor(columnDefsExcel?.length / headers?.length)}
                                    >
                                        {filters?.branch?.name}
                                    </TableCell>}
                                    {(filters?.rptOptions?.id === 3) && <TableCell
                                        className="ReportItemHead"
                                        style={{
                                            fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                                        }}
                                        colSpan={Math.floor(columnDefsExcel?.length / headers?.length)}
                                    >
                                        {filters?.user?.name}
                                    </TableCell>}
                                </TableRow>
                                <TableRow ><TableCell colSpan={columnDefsExcel?.length}></TableCell></TableRow>
                            </TableHead>
                            <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
                                <TableRow>
                                    {columnDefsExcel?.map((col, index) => (
                                        <TableCell key={`CityHeader-${index}`} style={{
                                            ...col.headerSx,
                                            backgroundColor: '#DAEDFE',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            color: '#444',
                                            height: '36px',
                                            whiteSpace: 'pre',
                                            padding: '6px'
                                        }}>
                                            {col.headerName}
                                        </TableCell>
                                    ))}

                                </TableRow>
                            </TableHead>
                            {tableData?.length > 0 ? <TableBody>
                                {(
                                    // rowsPerPage > 0
                                    //     ? tableData.slice(
                                    //         page * rowsPerPage,
                                    //         page * rowsPerPage + rowsPerPage
                                    //     )
                                    //     : 
                                    tableData
                                ).map((val, index) => (
                                    <TableRow>

                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right', minWidth: '50px' }}>
                                            {val?.srNo}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.Provider}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.Business}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.PayType}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.Mode}
                                        </TableCell>

                                        <TableCell sx={{ height: '40px', fontSize: '12px', width: '12%', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.ModeV}
                                        </TableCell>

                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.OrderID}
                                        </TableCell>

                                        <TableCell sx={{ height: '40px', fontSize: '12px', width: '12%', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.TranID}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.TranIniOn}
                                        </TableCell>

                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.TranCompOn}
                                        </TableCell>

                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.TranAmt}
                                        </TableCell>

                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px' }}>
                                            {val?.TranFee}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px' }}>
                                            {val?.GST}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px' }}>
                                            {val?.utrNo}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px' }}>
                                            {val?.TranStaus}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px' }}>
                                            {val?.PaymentStatus}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px' }}>
                                            {val?.PNR}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px' }}>
                                            {val?.TransDate}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px' }}>
                                            {val?.TranAmt}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px' }}>
                                            {val?.settelmentStatus}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px' }}>
                                            {val?.settelmentId}
                                        </TableCell> <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px' }}>
                                            {val?.settelmentDateTime}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px' }}>
                                            {val?.BookedBy}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody> :
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={columnDefs?.length}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    marginTop: '20px',
                                                    marginBottom: '20px',
                                                    color: 'red',
                                                    fontSize: '14px',
                                                }}
                                            >
                                                <span>No Results Found For The Selected Filters.</span>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>}
                        </Table>
                    </TableContainer>
                    <TablePaginationCustom totRowCount={tableData?.length} rowsPerPageOptions={[10, 20, 50, 100, 200, 500]} rowsPerPage={rowsPerPage} page={page} handleChangePage={(event, newPage) => {
                        setPage(newPage);
                    }} handleChangeRowsPerPage={(event) => {
                        setRowsPerPage(parseInt(event.target.value, 10));
                        setPage(0);
                        handleLoad(0, parseInt(event.target.value, 10))
                    }} />
                </Box>}
            <SuccessAndErrorModal
                handleClose={() => {
                    setIsSuccess(false);
                    window.location.reload()
                }} open={isSuccess} title={`Recharge Request Submitted\nSuccessfully`} modalStyle={modalStyle} />

        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
    getQRTransactionReportData, getBranchDetails, getUserMasterTableData, BranchRechargeConfirm, updateAlertError
}
export default connect(mapStateToProps, mapDispatchToProps)(QRTransactionReport)
